import SearchBar from './searchBar';

export default function install(Vue) {
  Vue.component('search-bar', SearchBar);
}



//////////////////
// WEBPACK FOOTER
// ./~/edoc-library/src/components/searchBar/index.js
// module id = 654
// module chunks = 41